import React, { Component } from "react";
import { Link } from "react-router-dom";
import KpitLogo from "./../../images/automate_kpi/automate_kpi_icon.png";
import about from "./../../images/automate_kpi/about_automatekpi_logo.png";
import AdminLogo from "./../../images/automate_kpi/admin-avatar.png";

class AutomateKpiWelcome extends Component {
  render() {
    return (
      <div data-test="automateKpiWelcomeComponent">
        <div className="navbar" style={{ display: "block", padding: "0%" }}>
          <ul
            style={{
              backgroundColor: "#E2E2E2",
              margin: "0",
              listStyleType: "none",
              padding: "0",
            }}
          >
            <li className="automatekpitlogo">
              <Link to="/navigate_new">
                <img
                  src={KpitLogo}
                  alt="Kpit_logo"
                  style={{
                    backgroundColor: "white",
                    width: "17%",
                    padding: "1%",
                  }}
                ></img>
              </Link>
              <h4
                style={{
                  display: "inline-block",
                  paddingLeft: "3%",
                  color: "#464646",
                  fontWeight: "bold",
                }}
              >
                Traffic Jam Assistance
              </h4>
              <img
                src={AdminLogo}
                alt="profile pic"
                style={{
                  float: "right",
                  width: "9%",
                  borderRadius: "50%",
                  paddingRight: "6%",
                  paddingTop: "1%",
                }}
              ></img>
              <img
                src={about}
                alt="to_do"
                style={{
                  float: "right",
                  width: "10%",
                  paddingTop: "2%",
                  paddingRight: "2%",
                }}
              ></img>
            </li>
          </ul>
        </div>
        <div className="row" style={{ paddingTop: "5%" }}>
          <div style={{ margin: "auto" }}>
            <h1 style={{ color: "#464646" }}>Welcome!</h1>
          </div>
        </div>
        <div className="row" style={{ paddingTop: "8%" }}>
          <div className="col-md-6">
            <Link
              to="/welcomeautomatekpi/landingkpidashboard"
              style={{ textDecoration: "none" }}
            >
              <div className="card" id="info-box">
                <div className="card-body align-items-center d-flex justify-content-center">
                  <h4 style={{ color: "#622AD8" }}>KPI Dashboard</h4>
                </div>
              </div>
            </Link>
          </div>
          <div className="col-md-6">
            <Link to="/kpi_manager" style={{ textDecoration: "none" }}>
              <div className="card" id="info-box">
                <div className="card-body align-items-center d-flex justify-content-center">
                  <h4 style={{ color: "#622AD8" }}>KPI Manager</h4>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

export default AutomateKpiWelcome;
